import type { ReactNode } from 'react';
import { cx } from '@/styled-system/css';
import {
  listingSummaryOverflow,
  moduleContainer,
  moduleContent,
  moduleFooter,
  moduleHeaderRow,
  moduleTitle,
  moduleTopPadding,
} from './module.styles';

type ModuleProps = {
  id: string;
  title?: string;
  headerActions?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  className?: string;
};

export const Module = ({ title, headerActions, children, footer, className, id }: ModuleProps) => {
  const isListingSummary = id === 'listing-summary-module';
  const heading = title ? <h2 className={moduleTitle}>{title}</h2> : null;

  return (
    <article
      className={cx(
        moduleContainer,
        isListingSummary && listingSummaryOverflow,
        !isListingSummary && moduleTopPadding,
        className,
      )}
      id={id}
    >
      {headerActions ? (
        <div className={moduleHeaderRow}>
          {heading}
          {headerActions}
        </div>
      ) : (
        heading
      )}

      <div className={moduleContent} data-module-content="">
        {children}
      </div>

      {footer && <div className={moduleFooter}>{footer}</div>}
    </article>
  );
};

export type { ModuleProps };
